import {lazy} from '@aboutyou/lazy-imports';
import {
  CHECKOUT_WRAPPER_MIN_HEIGHT,
  CheckoutAnimation,
} from '@aboutyou/logic-components';
import {styled} from '@linaria/react';
import React from 'react';

const CheckoutPageLazy = lazy(
  () =>
    import('./CheckoutPage.eager').then(mod => ({
      default: mod.CheckoutPageEager,
    })),
  {
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);

export const CheckoutPage = () => {
  return (
    <PageContainer>
      <AnimationOverlay>
        <CheckoutAnimation.Begin type="fancy-animation" />
      </AnimationOverlay>
      <CheckoutPageLazy />
    </PageContainer>
  );
};
CheckoutPage.preload = CheckoutPageLazy.preload;

// min-height matches Checkout's own PageWrapper (105vh) so the reserved space
// stays stable while the animation overlay is showing and once the lazy
// Checkout mounts, instead of both stacking their own heights and causing the
// footer below to jump.
const PageContainer = styled.div`
  position: relative;
  min-height: ${CHECKOUT_WRAPPER_MIN_HEIGHT};
`;

const AnimationOverlay = styled.div`
  position: absolute;
  inset: 0;
`;
